import React from 'react';
import {ConfirmMessageIcon} from "../../../assets/icons/Icons";
import Message from "../../Message";
import {useTranslation} from "react-i18next";

const OrderCreationMessage = () => {
    const { t } = useTranslation();
    return (
        <div className="step">
            <div className="multistep-form-confirmation-message">
                <h2 className="multistep-form-confirmation-message__title"><span
                    className="multistep-form-confirmation-message__title--icon"><ConfirmMessageIcon/></span> {t("Order successfully submitted!")}
                </h2>
            </div>
        </div>
    );
};

export default OrderCreationMessage;
